module.exports = __webpack_public_path__ + "img/contract_1.0de669f7.svg";